module.exports = __webpack_public_path__ + "static/media/1.280e768f.png";